export var OpTypeEnum;
(function (OpTypeEnum) {
    OpTypeEnum["BIOMETRIC_LOGIN"] = "BIOMETRIC_LOGIN";
    OpTypeEnum["PUBLIC_KEY_UPLOAD"] = "PUBLIC_KEY_UPLOAD";
    OpTypeEnum["BIOMETRIC_AUTH_TOGGLE"] = "BIOMETRIC_AUTH_TOGGLE";
    OpTypeEnum["ACCOUNT_DELETE"] = "ACCOUNT_DELETE";
    // BANK_WIRE_WITHDRAWAL = 'BANK_WIRE_WITHDRAWAL',
    // STODO should be removed after expo
    OpTypeEnum["ENABLE_BIOMETRICS"] = "ENABLE_BIOMETRICS";
})(OpTypeEnum || (OpTypeEnum = {}));
//# sourceMappingURL=op-type.enum.js.map